import { useLocation } from 'react-router';
import { useMemo } from 'react';

export function usePath() {
  const location = useLocation();
  const { pathname, search } = location;

  return useMemo(() => `${pathname}${search.toString()}`, [pathname, search]);
}
